import { Locale } from '@lalalilo/enums'
import { getLocale } from '../../i18n/locale'
import logoDarkFrance from './assets/logo-dark-france.svg'
import logoDarkRenaissance from './assets/logo-dark-renaissance.svg'
import logoLightFrance from './assets/logo-light-france.svg'
import logoLightRenaissance from './assets/logo-light-renaissance.svg'

import styled from 'styled-components'

import { useTranslation } from 'react-i18next'
import { mobile, tablet } from '../style/media-queries'

enum LogoVersion {
  FR_ONLY = 'FR_ONLY',
  RL_DEFAULT = 'RL_DEFAULT',
}

export enum LogoTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export const logoPaths = {
  [LogoVersion.FR_ONLY]: {
    [LogoTheme.LIGHT]: logoLightFrance,
    [LogoTheme.DARK]: logoDarkFrance,
  },
  [LogoVersion.RL_DEFAULT]: {
    [LogoTheme.LIGHT]: logoLightRenaissance,
    [LogoTheme.DARK]: logoDarkRenaissance,
  },
}
interface LogoProps {
  logoTheme: LogoTheme
  className?: string
}

export const Logo: React.FC<LogoProps> = ({ logoTheme, className }) => {
  const browserLocale = getLocale()
  const [t] = useTranslation()
  let logoVersion = LogoVersion.RL_DEFAULT

  if (browserLocale === Locale.FR) {
    logoVersion = LogoVersion.FR_ONLY
  }

  return (
    <Image
      alt={t('logo_alt')}
      className={className}
      logoVersion={logoVersion}
      src={logoPaths[logoVersion][logoTheme]}
    />
  )
}

const Image = styled.img<{ logoVersion: LogoVersion }>`
  width: 167px;
  height: 60px;

  @media ${tablet} {
    ${props => props.logoVersion === LogoVersion.FR_ONLY && 'width: 100px'}
  }

  @media ${mobile} {
    height: 50px;
  }
`
